import TruckIconOutlined from 'components/icons/TruckIconOutlined';
import { FeatureGuide } from '../types';
import { howItHelps, tips, whatItIs } from './sections';

export const manifestGuide: FeatureGuide = {
    key: 'manifest',
    title: 'Manifest',
    icon: <TruckIconOutlined />,
    sections: [
        whatItIs(
            `Select the manifest and job you want to link this ENS declaration to. If the manifest you need doesn't exist yet, you need to create one.`
        ),
        howItHelps(
            'The ENS must be tied to a specific manifest and job so the declaration can be correctly traced back to the right movement and shipment records.'
        ),
        tips([
            'Search for an existing manifest first using the reference number.',
            `If no manifest exists yet, use the "Create Manifest" option - you won't lose your progress.`,
        ]),
    ],
};
